// возможно следует перенести в entities
export const countryIcons = {
  Россия: 'Russia_04032024.svg',
  'Россия, Страны СНГ': 'Russia_SNG_11022026.svg',
  США: 'USA_04032024.svg',
  Турция: 'Turkey_06032024.svg',
  Польша: 'Poland_04032024.svg',
  Индия: 'India_04032024.svg',

  Европа: 'Europ_06082024.svg',
  Япония: 'Japan_07042024.svg',
  Аргентина: 'Argentina_12042024.svg',
  Германия: 'Germany_18042024.svg',
  'Арабские Эмираты': 'Arab_Emirates_23072024.svg',
  Австрия: 'Austria_23072024.svg',
  Австралия: 'Australia_01082024.svg',
  Бельгия: 'Belgium_23072024.svg',
  Бразилия: 'Brazil_23072024.svg',
  Чили: 'Chile_23072024.svg',
  Колумбия: 'Colombia_23072024.svg',
  Финляндия: 'Finland_23072024.svg',
  Франция: 'France_23072024.svg',
  Гонконг: 'HongKong_23072024.svg',
  Индонезия: 'Indonesia_23072024.svg',
  Корея: 'Korea_23072024.svg',
  Ливан: 'Lebanon_23072024.svg',
  Малайзия: 'Malaysia_23072024.svg',
  Мексика: 'Mexico_23072024.svg',
  Нидерланды: 'Netherlands_23072024.svg',
  Перу: 'Peru_23072024.svg',
  Филиппины: 'Philippines_23072024.svg',
  'Саудовская Аравия': 'SaudiArabi_23072024a.svg',
  Сингапур: 'Singapore_23072024.svg',
  ЮАР: 'SouthAfrica_23072024.svg',
  'Южная Корея': 'SouthKorea_23072024.svg',
  Тайвань: 'Taiwan_23072024.svg',
  Таиланд: 'Thailand_31072024.svg',
  Великобритания: 'UnitedKingdom_23072024.svg',
  Вьетнам: 'Vietnam.svg',
  Словакия: 'Slovakia.svg',
  Италия: 'Italy_13082024.svg',
  Испания: 'Spain_13082024.svg',
  Ирландия: 'Ireland_13082024.svg',
  Алжир: 'Algeria_29082024.svg',
  Кувейт: 'Kuwait.svg',
  Катар: 'Qatar.svg',
  Португалия: 'Portugal.svg',
  Казахстан: 'Kazakhstan_20082024.svg',
  'Страны СНГ': 'SNG_04032024.svg',
  Канада: 'Canada_10032026.svg',
  Швейцария: 'Switzerland.svg',
  Швеция: 'Sweden.svg',
  Норвегия: 'Norway.svg',
  Венгрия: 'Hungary.svg',
  'США и Европа': 'Europ_USA_06082024.svg',
  'Любой регион': 'Global_04032024.svg',
}
